import React from 'react';
import { motion } from 'framer-motion';

const GooglePartner = () => {
  return (
    <section className="py-12 bg-white border-y border-black/5">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16"
        >
          <p className="text-[var(--text-secondary)] text-sm font-medium">
            Powered by industry-leading technology
          </p>
          <div className="flex items-center gap-10 md:gap-14">
            {/* Google Logo */}
            <div className="flex items-center gap-2 opacity-70 hover:opacity-100 transition-opacity">
              <svg viewBox="0 0 24 24" className="w-24 h-8" xmlns="http://www.w3.org/2000/svg">
                <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
              </svg>
            </div>
            {/* Google Workspace Logo */}
            <div className="flex items-center gap-2 opacity-70 hover:opacity-100 transition-opacity">
              <svg viewBox="0 0 192 192" className="w-8 h-8" xmlns="http://www.w3.org/2000/svg">
                <path fill="#4285F4" d="M96 96L30 150V42z"/>
                <path fill="#EA4335" d="M96 96l66-54H30z"/>
                <path fill="#34A853" d="M96 96l66 54V42z"/>
                <path fill="#FBBC05" d="M96 96l-66 54h132z"/>
              </svg>
              <span className="text-sm font-medium text-[var(--text-secondary)]">Workspace</span>
            </div>
            {/* Gemini Logo */}
            <div className="flex items-center gap-2 opacity-70 hover:opacity-100 transition-opacity">
              <svg viewBox="0 0 24 24" className="w-7 h-7" xmlns="http://www.w3.org/2000/svg">
                <defs>
                  <linearGradient id="gemini-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#4285F4"/>
                    <stop offset="50%" stopColor="#9B72CB"/>
                    <stop offset="100%" stopColor="#D96570"/>
                  </linearGradient>
                </defs>
                <path fill="url(#gemini-gradient)" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"/>
              </svg>
              <span className="text-sm font-medium text-[var(--text-secondary)]">Gemini AI</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default GooglePartner;
